import template from './settings-projects.pug';

export const SettingsProjectsComponent = {
  template,
  bindings: {},
  controller: class SettingsProjectsComponent {
    constructor() {
      'ngInject';
    }

    $onInit() {}
  }
};
